import {
  INCOMPLETE_ORDERS_REQUESTED,
  INCOMPLETE_ORDERS_SUCCESS,
  INCOMPLETE_ORDERS_FAILURE,
  ORDER_WITH_SHIPMENTS_REQUESTED,
  ORDER_WITH_SHIPMENTS_SUCCESS,
  ASSIGNMENT_CREATE_REQUESTED,
  ASSIGNMENT_CREATE_SUCCESS,
} from '../types';

const INITIAL_STATE = {
  activeOrder: null,
  orders: [],
  ordersPagination: {},
  isFetching: false,
  status: 'waiting',
  errors: null
};

const incompleteOrders = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case INCOMPLETE_ORDERS_REQUESTED:
      return Object.assign({}, state, {
        orders: [],
        ordersPagination: {},
        isFetching: true,
        status: 'requested',
        errors: null
      });

    case INCOMPLETE_ORDERS_SUCCESS:
      return Object.assign({}, state, {
        orders: action.payload.orders || [],
        ordersPagination: action.payload.order_pagination,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case INCOMPLETE_ORDERS_FAILURE:
      return Object.assign({}, state, {
        orders: [],
        ordersPagination: {},
        isFetching: false,
        status: 'error',
        errors: action.error
      });

    case ORDER_WITH_SHIPMENTS_REQUESTED:
      newState.activeOrder = null;
      newState.isFetching = true;
      return newState;

    case ORDER_WITH_SHIPMENTS_SUCCESS:
      newState.activeOrder = action.payload;
      newState.isFetching = false;
      return newState;


    case ASSIGNMENT_CREATE_REQUESTED:
    case ASSIGNMENT_CREATE_SUCCESS:
      // This could probably be better, not really duplicating correctly so no updates on success, but should be only on success, shouldn't eliminate so much stuff
      if(action.payload.assignmentValues.type === 'variation' && newState.activeOrder) {
        newState.activeOrder.variation_metafields[`${action.payload.assignmentValues.productId}/${action.payload.assignmentValues.variationId}`] = [{
          body: {
            minimum_order: action.payload.assignmentValues.minimumQuantity,
            supplier_sku: action.payload.assignmentValues.supplierSku,
            supplier_price: action.payload.assignmentValues.supplierPrice,
          },
          supplier_id: action.payload.supplierId,
          type: 'supplier'
        }]
      }

      if(action.payload.assignmentValues.type === 'product' && newState.activeOrder) {
        newState.activeOrder.product_metafields[`${action.payload.assignmentValues.productId}`] = [{
            body: {
              minimum_order: action.payload.assignmentValues.minimumQuantity,
              supplier_sku: action.payload.assignmentValues.supplierSku,
              supplier_price: action.payload.assignmentValues.supplierPrice,
            },
            supplier_id: action.payload.supplierId,
            type: 'supplier'
          }]
      }

      return newState;


    default:
      return state;
  }
}

export default incompleteOrders;
